import React from 'react';
import clsx from 'clsx';
import { Box } from '../Box';
export function DatePickerMenuItem(props) {
    const { children, className, selected, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, type: "button", elementType: "button", className: clsx('mollie-ui-date-picker-menu-item', {
            'mollie-ui-date-picker-menu-item--selected': selected,
        }, className), "aria-current": selected ? 'true' : undefined }, children));
}
DatePickerMenuItem.displayName = 'DatePicker.MenuItem';
//# sourceMappingURL=DatePickerMenuItem.js.map